import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const NAMES = ['Ana', 'María', 'Sofía', 'Valentina', 'Camila', 'Lucía', 'Isabella', 'Gabriela', 'Carolina', 'Daniela', 'Fernanda', 'Alejandra', 'Paola', 'Andrea', 'Natalia', 'Laura', 'Diana', 'Claudia', 'Patricia', 'Rosa'];
const COUNTRIES = ['México', 'Colombia', 'Argentina', 'Chile', 'Perú', 'Ecuador', 'Venezuela', 'República Dominicana', 'Guatemala', 'Costa Rica', 'Estados Unidos', 'España', 'Bolivia', 'Paraguay', 'Uruguay', 'Honduras', 'Panamá'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    country: '',
    time: 0
  });
  useEffect(() => {
    // Start showing after 5 seconds
    const initialDelay = setTimeout(() => {
      showNextPopup();
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  const showNextPopup = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const lastInitial = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const country = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
    const time = Math.floor(Math.random() * 14) + 2; // 2 to 15 minutes
    setCurrentPurchase({
      name: `${name} ${lastInitial}.`,
      country,
      time
    });
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (7 to 10 seconds after hiding)
      const nextDelay = Math.floor(Math.random() * 3000) + 7000;
      setTimeout(showNextPopup, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-43">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-6 left-6 z-40 bg-white rounded-xl shadow-xl border border-[#C8956C]/20 p-4 pr-8 flex items-center gap-4 max-w-sm" data-id="element-44">
          <div className="bg-[#7C9A6E]/10 p-2 rounded-full" data-id="element-45">
            <CheckCircle2Icon className="w-6 h-6 text-[#7C9A6E]" data-id="element-46" />
          </div>
          <div data-id="element-47">
            <p className="text-sm font-bold text-[#3D2B1F]" data-id="element-48">
              {currentPurchase.name} de {currentPurchase.country}
            </p>
            <p className="text-xs text-[#5A4332]" data-id="element-49">
              compró hace {currentPurchase.time} minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}